export const containerWidths = {
  maxWidthContainer: 980,
  videoHeroContainer: 720,
  caseStudyHeroContainer: 980,
  standbyHeroContainer: 980,
};
